export default {"src":"/_next/static/media/logo_wh.74788a98.svg","height":41,"width":193,"blurWidth":0,"blurHeight":0};